import React, { useState, useEffect } from 'react';
import './printerdata.scss';
import '../topbar/topbar.scss';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import AddIcon from '@mui/icons-material/Add';
import { Link } from 'react-router-dom';

const Printerdata = () => {
  const [printers, setPrinters] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchPrinters = async () => {
      try {
        const storedToken = localStorage.getItem('accessToken');

        const response = await fetch(`${apiUrl}/printers`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${storedToken}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch printers');
        }

        const data = await response.json();
        setPrinters(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchPrinters();
  }, [apiUrl]); // ✅ FIXED

  return (
    <>
      <div className="navbar">
        <div className="wrapper">
          <div className="items">
            <div className="item">
              <Link to="/printers/addPrinter" style={{ textDecoration: 'none' }}>
                <AddIcon className="icon" />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <TableContainer component={Paper} className="reporttable">
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell>Printer Name</TableCell>
              <TableCell>SN</TableCell>
              <TableCell>Port</TableCell>
              <TableCell>Location</TableCell>
              <TableCell>Printer Type</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {printers.map((printer) => (
              <TableRow key={printer._id}>
                <TableCell>{printer.name}</TableCell>
                <TableCell>{printer.sn}</TableCell>
                <TableCell>{printer.port}</TableCell>
                <TableCell>{printer.location}</TableCell>
                <TableCell>{printer.printerType}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default Printerdata;